// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout_header__3fN55","content":"Layout_content__1ePrt","footer":"Layout_footer__1yMiB"};